import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  isLoggedIn = false;
  isDropdownOpen = false;
  isHovered = false;
  hoverTimer?: number;
  userName: string | null = null;
  isMobileMenuOpen = false;
  isGuestUser = false;

  private readonly destroy$ = new Subject<void>();
  private subscriptions = new Subscription();

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  ngOnInit(): void {
    const loginSub = this.authService.isLoggedIn$
      .pipe(takeUntil(this.destroy$))
      .subscribe((status: boolean) => {
        this.isLoggedIn = status;
        if (status) {
          const user = this.authService.getUser();

          if (user?.level === 'basic' || user?.level === 'pro') {
            this.userName = [user?.first_name, user?.middle_name, user?.last_name]
              .filter(Boolean)
              .join(' ')
              .trim();
          } else {
            this.isGuestUser = true;
            this.userName = 'Guest User';
          }
        } else {
          this.userName = null;
        }
      });

    this.subscriptions.add(loginSub);
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/']);
  }

  toggleMobileMenu(): void {
    const menu = document.querySelector('.mobile-menu') as HTMLElement;
    const body = document.querySelector('body') as HTMLElement;
    menu.classList.toggle('hidden');

    if (!menu.classList.contains('hidden')) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = '';
    }
  }

  onMouseEnter(): void {
    this.isHovered = true;
    if (!this.isDropdownOpen) {
      clearTimeout(this.hoverTimer);
      this.isDropdownOpen = true;
    }
  }

  onMouseLeave(): void {
    this.isHovered = false;
    this.isDropdownOpen = false;
  }

  onToggleClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
